import axios from 'axios';

export let axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:8000/api',
  withCredentials: true,
});
